import { css } from '@styled-system/css';
import { type FC } from 'react';
import Skeleton from 'react-loading-skeleton';

export const ProductItemSkeleton: FC = () => {
  const cardStyles = css({
    display: 'flex',
    flexDirection: 'row',
    gap: 'sm',
    alignItems: 'flex-start',
    bg: 'transparent',
    w: 'fit-content',
    h: 'fit-content',
    minW: 0,
    flexShrink: 0,
  });

  const photoSectionStyles = css({
    display: 'flex',
    flexDirection: 'column',
    gap: 'xs',
    alignItems: 'flex-start',
    w: '6.8125rem',
    flexShrink: 0,
  });

  const miniPhotosStyles = css({
    display: 'flex',
    flexDirection: 'row',
    gap: 'xs',
    alignItems: 'center',
    w: '100%',
  });

  const contentSectionStyles = css({
    display: 'flex',
    flexDirection: 'column',
    h: '10.3125rem',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    w: '15.8125rem',
    flexShrink: 0,
  });

  const mainContentStyles = css({
    display: 'flex',
    flexDirection: 'column',
    gap: '0.8rem',
    alignItems: 'flex-start',
    w: '100%',
    flexShrink: 0,
  });

  const headerStyles = css({
    display: 'flex',
    flexDirection: 'column',
    gap: '2xs',
    alignItems: 'flex-start',
    w: '100%',
    flexShrink: 0,
  });

  const priceTagRowStyles = css({
    display: 'flex',
    flexDirection: 'row',
    gap: 'xs',
    alignItems: 'flex-start',
    flexShrink: 0,
  });

  const categoryProductStyles = css({
    display: 'flex',
    flexDirection: 'column',
    gap: 0,
    alignItems: 'flex-start',
    flexShrink: 0,
  });

  const productInfoStyles = css({
    display: 'flex',
    flexDirection: 'row',
    gap: 'xs',
    alignItems: 'center',
    flexShrink: 0,
  });

  const sellContentStyles = css({
    display: 'flex',
    mt: '3rem',
    flexDirection: 'row',
    gap: 'sm',
    alignItems: 'center',
    flexShrink: 0,
  });

  return (
    <div className={cardStyles}>
      {/* Section photo */}
      <div className={photoSectionStyles}>
        <Skeleton height="6.8125rem" width="6.8125rem" style={{ borderRadius: '0.5rem' }} />

        <div className={miniPhotosStyles}>
          <Skeleton height="3.25rem" width="3.25rem" style={{ borderRadius: '0.5rem' }} />
          <Skeleton height="3.25rem" width="3.25rem" style={{ borderRadius: '0.5rem' }} />
        </div>
      </div>

      {/* Section contenu */}
      <div className={contentSectionStyles}>
        <div className={mainContentStyles}>
          {/* Header */}
          <div className={headerStyles}>
            <Skeleton height="0.7rem" width="5rem" />
            <div className={priceTagRowStyles}>
              <Skeleton height="1rem" width="5.5rem" />
              <Skeleton height="1rem" width="6.5rem" style={{ borderRadius: '1.5rem' }} />
            </div>
          </div>

          <div className={categoryProductStyles}>
            <div className={productInfoStyles}>
              <Skeleton height="0.7rem" width="3.25rem" />
              <Skeleton height="0.7rem" width="3.5rem" />
            </div>
            <div className={productInfoStyles}>
              <Skeleton height="0.7rem" width="3.25rem" />
              <Skeleton height="0.7rem" width="3.5rem" />
            </div>
          </div>
        </div>

        <div className={sellContentStyles}>
          <Skeleton height="0.625rem" width="7rem" />
          <Skeleton height="0.625rem" width="7rem" />
        </div>
      </div>
    </div>
  );
};
